import { createContext, useContext, useMemo, type ReactNode } from 'react';

import { createMockSupportService } from './mock-support.service';
import type { SupportService } from './support.service';

const SupportServiceContext = createContext<SupportService | null>(null);

/**
 * TODO(DEV-4304): the default service is the mock (always on, no flag) because
 * POST /support/tickets does not exist yet. To switch to the real backend, add
 * `createRestSupportService()` implementing `SupportService` (multipart:
 * category, description, timePeriod, timeZone, files[]) and use it here instead
 * of `createMockSupportService()`; nothing else in the module changes.
 */
export function SupportServiceProvider({
  children,
  service,
}: {
  children: ReactNode;
  service?: SupportService;
}) {
  const value = useMemo(() => service ?? createMockSupportService(), [service]);
  return <SupportServiceContext.Provider value={value}>{children}</SupportServiceContext.Provider>;
}

export function useSupportService(): SupportService {
  const ctx = useContext(SupportServiceContext);
  if (!ctx) {
    throw new Error('useSupportService must be used within a SupportServiceProvider');
  }
  return ctx;
}
